import { ArrowRight } from "lucide-react";
import { type ReactNode } from "react";
import { Link } from "react-router";

type ActivityLogNoteProps = {
  header: ReactNode;
  text: string;
  link: string | false;
};

export function ActivityLogNote({ header, text, link }: ActivityLogNoteProps) {
  if (!text) {
    return null;
  }

  const plainText = text.replace(/\s+/g, " ").trim();

  const textElement = (
    <p className="text-sm line-clamp-3 overflow-hidden">{plainText}</p>
  );

  return (
    <div className="p-0">
      <div className="flex flex-col space-y-2 w-full">
        <div className="flex flex-row space-x-1 items-center w-full">
          {header}
        </div>
        <div className="md:max-w-150 [&_p]:my-auto">
          {link !== false ? (
            // Mejora #2 (Musco): make link explicit — el bloque entero es
            // clickeable, con indicador visual "Abrir detalle →" al hover
            // para que sea evidente que navega al contacto/oportunidad.
            <Link
              to={link}
              className="group flex items-start justify-between gap-2 rounded p-1 transition-colors hover:bg-muted"
            >
              {textElement}
              <span className="flex items-center gap-1 text-xs text-primary opacity-0 transition-opacity group-hover:opacity-100 whitespace-nowrap shrink-0 pt-0.5">
                Abrir detalle
                <ArrowRight className="h-3 w-3" />
              </span>
            </Link>
          ) : (
            textElement
          )}
        </div>
      </div>
    </div>
  );
}
